import { useContext } from "react";
import { ChatSocketContext } from "./ChatSocketProvider";

const useChatSocket = () => useContext(ChatSocketContext);
export default useChatSocket;
